// extracted by mini-css-extract-plugin
module.exports = {"container":"address_container_1I_fy","info":"address_info_1oKL4","title":"address_title_2Idt5","slotTag":"address_slotTag_a8d0l"};